import axios from 'axios';

export default {
  get: params => axios.get('/api/v1/gmva/deckblatt', { params }),
  getPdf: params => axios.get(`/api/v1/gmva/deckblatt/${params.id}/pdf`),
  create: params => axios.post(`/api/v1/gmva/deckblatt`, { ...params }),
  getDataForNewDeckblatt: params => axios.get(`/api/v1/gmva/deckblatt/new-deckblatt`, { ...params }),
};
